import { useCallback, useEffect, useState } from 'react';

import { Download, QrCode } from 'lucide-react';
import QRCode from 'qrcode';

function LicenseQRCodeCard({ licenseNumber }: { licenseNumber: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    QRCode.toDataURL(licenseNumber, {
      width: 320,
      margin: 2,
      errorCorrectionLevel: 'M',
      color: { dark: '#1e293b', light: '#ffffff' },
    })
      .then(setDataUrl)
      .catch(() => setDataUrl(null));
  }, [licenseNumber]);

  const handleDownload = useCallback(() => {
    if (!dataUrl) return;
    const link = document.createElement('a');
    link.download = `licence-${licenseNumber}.png`;
    link.href = dataUrl;
    link.click();
  }, [dataUrl, licenseNumber]);

  return (
    <div className='rounded-2xl bg-white border border-slate-100 shadow-sm p-6'>
      <h2 className='mb-4 flex items-center gap-2 text-base font-bold text-slate-900'>
        <QrCode className='h-4 w-4 text-blue-500' />
        Ma licence (QR Code)
      </h2>

      <p className='mb-4 text-xs text-slate-500 leading-relaxed'>
        Présentez ce QR code lors de l&apos;inscription en concours pour pré-remplir automatiquement votre numéro de
        licence.
      </p>

      <div className='flex items-center justify-center rounded-xl bg-white p-4 border border-slate-100'>
        {dataUrl ? (
          <img src={dataUrl} alt={`QR licence ${licenseNumber}`} className='h-40 w-40' />
        ) : (
          <div className='h-40 w-40 animate-pulse rounded-lg bg-slate-100' />
        )}
      </div>

      <p className='mt-3 text-center font-mono text-sm font-bold tracking-widest text-slate-700'>{licenseNumber}</p>

      <button
        onClick={handleDownload}
        disabled={!dataUrl}
        className='mt-4 flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border border-slate-200 bg-slate-50 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 disabled:opacity-40'
      >
        <Download className='h-4 w-4' />
        Télécharger le QR code
      </button>
    </div>
  );
}

export default LicenseQRCodeCard;
